import {observer} from "mobx-react-lite"
import React, {useEffect, useState} from "react"
import controller from "./ExportStatusController"
import {Link, match, Route, useHistory} from "react-router-dom"

import {appPages} from "../../App";

import {SkeletonBox} from "../../lib/wa-2.0"
import ReactPaginate from "react-paginate"


const ExportHistoryComponent = observer(({match}: { match: match}) => {
    // const [launches, setLaunches] = useState<LaunchAnswer[] | undefined>()

    useEffect(() => {
        controller.loadHistory()
    }, [])

    const history = useHistory();
    const handleRowClick = (id: number) => {
        history.push(appPages.exportHistory + '/launch/' + id);
    }

    return <div>
        <h1>6. Статус экспорта</h1>
        {controller.historyLoaded ? <table>
            <thead style={{backgroundColor: "#F3F3F3"}}>
                <tr>
                    <th>Запуск экспорта</th>
                    <th></th>
                    <th>Отправлено товаров</th>
                </tr>
            </thead>
            <tbody>
            {controller.launches.map((item, index) =>
                <tr key={index} onClick={()=>handleRowClick(item.id)}  style={{cursor:'pointer'}}>
                    <td>{item.datetime}</td>
                    <td></td>
                    <td>{item.sku_count}</td>
                </tr>
            )}
            </tbody>
        </table> : controller.loadFinished ? <div>Экспорта товаров еще не было</div> : <SkeletonBox/>}
        {controller.countOfPages > 1 &&
        <div className={'paginate-compare'}>
            <ReactPaginate
                previousLabel={'Предыдущая'}
                nextLabel={'Следующая'}
                containerClassName={'paging'}
                pageCount={controller.countOfPages}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                initialPage={controller.page}
                onPageChange={({selected}) => {
                    controller.loadHistory(selected)
                }
                }
            />
        </div>}
    </div>
})

export default ExportHistoryComponent